import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const NoPhotoIcon = props => {
    const {title} = props;
    return (
        <span className="fa-layers fa-fw no-photo-icon" title={title ?? "No photo available at this photo point for this event."}>
            <FontAwesomeIcon icon={['fas', 'camera']} transform="shrink-7" />
            <FontAwesomeIcon icon={['fal', 'ban']} />
        </span>
    );
};


